var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridFeedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.986816,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#DB7923"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_885_3137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6081 28.987H27.1336L26.2395 15.5586H23.5021L22.6081 28.987ZM26.2375 28.1299H23.5042L24.2852 16.4157H25.4577L26.2375 28.1299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 18.7012H21.3811V19.5583H28.5V18.7012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0812 17.4155H27.2437V18.7012H28.0812V17.4155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6374 17.4155H21.7999V18.7012H22.6374V17.4155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 28.1299H21.3811V28.987H28.5V28.1299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3661 28.8441H17.3075L16.3251 10.9868H13.349L12.3661 28.8441ZM16.4222 27.987H13.2518L14.1408 11.844H15.5332L16.4222 27.987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8686 13.9868H10.9122V14.844H18.8686V13.9868Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4498 12.7012H17.6123V13.9869H18.4498V12.7012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8686 28.1299H10.4935V28.987H18.8686V28.1299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4574 15.3462L15.8653 14.7402L13.0764 17.5945L13.6685 18.2005L16.4574 15.3462Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2856 19.8234L25.6893 19.2217L23.1081 21.9007L23.7044 22.5024L26.2856 19.8234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5076 25.2032L25.9154 24.5972L22.7601 27.8265L23.3522 28.4325L26.5076 25.2032Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6261 20.0852L13.9155 17.311L13.3234 17.917L16.034 20.6912L16.6261 20.0852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6763 24.7995L23.9657 22.0254L23.3736 22.6314L26.0842 25.4055L26.6763 24.7995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4574 20.0606L15.8653 19.4546L12.7623 22.6303L13.3544 23.2363L16.4574 20.0606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8879 25.4961L13.9155 22.4541L13.3234 23.0601L16.2958 26.1021L16.8879 25.4961Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4461 26.0715L15.8766 25.4424L13.0336 28.1381L13.6032 28.7668L16.4461 26.0715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1949 14.5711L12.702 13.8888C12.1923 13.5011 11.7137 13.0725 11.2707 12.6069L10.653 13.1855C11.1291 13.6897 11.6448 14.1531 12.1949 14.5711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5465 18.1866C22.6861 18.1866 22.8257 18.1849 22.9653 18.1815L22.9448 17.3244C20.6942 17.383 18.4572 16.9509 16.3824 16.0566L16.0591 16.8478C18.1129 17.7317 20.3185 18.1869 22.5465 18.1866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0394 18.2771C28.16 18.2771 28.2814 18.2755 28.4037 18.2724L28.3836 17.4153C26.5399 17.4506 24.7076 17.1118 22.9924 16.4185C21.2773 15.7252 19.7133 14.6912 18.3908 13.376L17.7727 13.9545C20.5058 16.722 24.1947 18.2752 28.0394 18.2771Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_885_3137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 28.5 10.9868)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridFeedIn);
export default __webpack_public_path__ + "static/media/grid-feed-in.1f899966c8620f32add17f8838eaa0d8.svg";
export { ForwardRef as ReactComponent };